<template>
    <div class="grid grid-rows-[min-content_1fr] gap-8">
        <ClosinglockHeader portal="employee">
            <template #navigation> <EmployeeNavigation /> </template>
            <template #warning>
                <ShadowWarning v-if="shadowStore.isShadowing" />
            </template>
        </ClosinglockHeader>

        <RouterView />
    </div>
</template>

<script setup lang="ts">
import { useCurrentUserService } from '@/services/current-user.service';
import { onMounted } from 'vue';

import ClosinglockHeader from '@/components/Navigation/ClosinglockHeader.vue';
import EmployeeNavigation from '@/components/Navigation/top-nav/EmployeeNavigation.vue';
import ShadowWarning from '@/components/Navigation/top-nav/ShadowWarning.vue';
import { useShadowAccountStore } from '@/stores/shared/shadow-account.store';

defineProps<{
    currentUser: unknown;
    userAccountId: number;
    supportAccountId: string;
    userHasEmployeeRole: boolean;
    csrf_token: string;
}>();

const currentUserService = useCurrentUserService();
const shadowStore = useShadowAccountStore();

onMounted(() => {
    currentUserService.loadGlobalUserOrLogout();
});
</script>
